/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { MyShowsFilterList, MyShowsItemV2, SelectedMyShowsItem } from 'client-code/myshows';

import { MyShowsServiceRepositoryImpl } from '../impls/MyShowsServiceRepositoryImpl';
import { MyShowsServiceRepositoryImplV2 } from '../impls/MyShowsServiceRepositoryImplV2';
import { IMyShowsServiceRepository } from '../interfaces';
import { IMyShowsService } from '../interfaces/IMyShowsService';
import { TMyShowsItemList, TMyShowsItemListParams, TServicesParams, TStorageInfo } from '../types';

export class MyShowsService implements IMyShowsService {
    private oMyShowsServiceRepository: IMyShowsServiceRepository;

    private oMyShowsServiceRepositoryV2: IMyShowsServiceRepository;

    private static lastSelectedMyShowsItem: SelectedMyShowsItem | undefined;

    private static myShows: Array<MyShowsItemV2> = [];

    private static myShowsCount: number = 0;

    public constructor(params: TServicesParams) {
        this.oMyShowsServiceRepository = new MyShowsServiceRepositoryImpl(params);
        this.oMyShowsServiceRepositoryV2 = new MyShowsServiceRepositoryImplV2(params);
    }

    private async fetchDataOrCallService({
        myShowsFilter,
        notCurrentlyAvailable,
        recentlyDeleted,
        streamingMovies,
        count,
        offset,
        orderBy,
        unifiedCollectionId,
        networkCallId,
    }: TMyShowsItemListParams): Promise<TMyShowsItemList> {
        // TODO: Need to update the caching logic

        // const storedShows = MyShowsService.myShows || [];
        // const storedCount = MyShowsService.myShowsCount || 0;
        // const requestedOffset = offset && offset >= 0 ? offset : 0;
        // if data is available in cache
        // if (
        //     myShowsFilter === MyShowsService.previousSelectedFilter &&
        //     count &&
        //     requestedOffset + count <= storedCount
        // ) {
        //     return {
        //         lastSelectedItem: MyShowsService.lastSelectedMyShowsItem,
        //         myShows: storedShows.slice(requestedOffset, requestedOffset + count),
        //         totalMyShowsCount: storedCount,
        //         sortOrder: storedSortOrder,
        //     };
        // }
        // MyShowsService.previousSelectedFilter = myShowsFilter;
        // if data is not available
        // const fetchOffset = Math.max(requestedOffset, storedCount);
        // const fetchCount = count ? Math.max(0, requestedOffset + count - storedCount) : undefined;

        const newData = await this.oMyShowsServiceRepositoryV2.getMyShowsItemList({
            myShowsFilter,
            notCurrentlyAvailable,
            recentlyDeleted,
            streamingMovies,
            count,
            offset,
            orderBy,
            unifiedCollectionId,
            networkCallId,
        });

        const newShows = newData.myShows;
        const newSelectedItem = newData.lastSelectedItem;

        // MyShowsService.myShows =
        //     requestedOffset === 0 ? newShows : [...storedShows.slice(0, fetchOffset), ...newShows];
        // MyShowsService.myShowsCount = MyShowsService.myShows.length;
        // MyShowsService.lastSelectedMyShowsItem = newSelectedItem;
        return {
            lastSelectedItem: newSelectedItem,
            myShows: newShows,
            totalMyShowsCount: newData.totalMyShowsCount,
            sortOrder: newData.sortOrder,
            networkCallId,
        };
    }

    public async getDiskSpace(networkCallId?: number): Promise<TStorageInfo> {
        return this.oMyShowsServiceRepository.getDiskSpace(networkCallId);
    }

    public async getMyShowsFilterList(): Promise<MyShowsFilterList> {
        return this.oMyShowsServiceRepository.getMyShowsFilterList();
    }

    public async setLastSelectedItem(myShowsItemId: string, myShowsFilter?: string) {
        return this.oMyShowsServiceRepository.setLastSelectedItem(myShowsItemId, myShowsFilter);
    }

    /**
     * @inheritdoc
     */
    public async getMyShowsItemList({
        myShowsFilter,
        notCurrentlyAvailable,
        recentlyDeleted,
        streamingMovies,
        count,
        offset,
        orderBy,
        unifiedCollectionId,
    }: TMyShowsItemListParams): Promise<TMyShowsItemList> {
        return this.fetchDataOrCallService({
            myShowsFilter,
            notCurrentlyAvailable,
            recentlyDeleted,
            streamingMovies,
            count,
            offset,
            orderBy,
            unifiedCollectionId,
        });
    }
}
